export const ANCHOR_ELEMENT = 'a';
export const DISPLAY_NONE = 'none';
export const DOWNLOAD_ACTION = 'download';
export const DOWNLOAD_ATTRIBUTE = 'download';
export const OPEN_IN_NEW_TAB_ACTION = 'open';